import React from 'react';
import { Window } from '../Window/Window';
import styled from 'styled-components';
import { DesktopIcon } from '../Desktop/DesktopIcon';

const FolderContent = styled.div`
  background: #c0c0c0;
  height: 100%;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  /* Target any DesktopIcon within the folder content */
  div {
    div {  /* Target the IconLabel specifically */
      color: black !important;
      text-shadow: none !important;
    }
  }

  /* Target the IconWrapper for hover effect */
  > div {  /* This targets the direct child div (IconWrapper) */
    height: fit-content !important;
    padding: 8px !important;
    border: 1px solid;
    border-color: #ffffff #808080 #808080 #ffffff; // Classic Windows 95 border colors
    
    &:hover {
      background: rgba(0, 0, 255, 0.1) !important;
      outline: 1px dotted #000080 !important;
    }

    &:active {
      border-color: #808080 #ffffff #ffffff #808080; // Invert border on click
    }
  }
`;

export const ProjectsFolder = ({ 
  onClose, 
  isActive, 
  onActivate, 
  isMinimized, 
  isMaximized, 
  onMinimize, 
  onMaximize,
  onFileOpen,
  initialPosition
}) => {
  const handleDavidOSClick = () => {
    onFileOpen('davidos.txt');
  };

  const handleAppleFarmClick = () => {
    console.log('Clicking apple farm');
    onFileOpen('apple farm.txt');
  };

  return (
    <Window
      title="Projects"
      onClose={onClose}
      isActive={isActive}
      onActivate={onActivate}
      isMinimized={isMinimized}
      isMaximized={isMaximized}
      onMinimize={onMinimize}
      onMaximize={onMaximize}
      defaultWidth="500px"
      defaultHeight="400px"
      initialPosition={initialPosition}
    >
      <FolderContent>
        <DesktopIcon
          icon="/images/dOSlogo.svg"
          label="davidos.txt"
          onDoubleClick={handleDavidOSClick}
        />
        <DesktopIcon
          icon="/images/apple.svg"
          label="apple farm.txt"
          onDoubleClick={handleAppleFarmClick}
        />
      </FolderContent>
    </Window>
  );
}; 